export const SvgSparkle = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.3636 0L15.2182 2.5L12.7273 3.63636L15.2182 4.78182L16.3636 7.27273L17.5 4.78182L20 3.63636L17.5 2.5M7.27273 2.72727L5 7.72727L0 10L5 12.2727L7.27273 17.2727L9.54545 12.2727L14.5455 10L9.54545 7.72727M16.3636 12.7273L15.2182 15.2182L12.7273 16.3636L15.2182 17.5L16.3636 20L17.5 17.5L20 16.3636L17.5 15.2182"
				fill="#AD8D40"
			/>
		</svg>
	);
};
